import { render, staticRenderFns } from "./HelpdeskIndex.vue?vue&type=template&id=e7ae0830&scoped=true"
import script from "./HelpdeskIndex.vue?vue&type=script&lang=js"
export * from "./HelpdeskIndex.vue?vue&type=script&lang=js"
import style0 from "./HelpdeskIndex.vue?vue&type=style&index=0&id=e7ae0830&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ae0830",
  null
  
)

export default component.exports